<template>
 

<v-row v-if="getField(field)">
    
    <v-col cols="3" v-if="!dense" class="d-flex align-center py-0">
        <div class="subtitle-1 font-weight-medium">{{ field.NAME }}</div>
    </v-col> 

    <v-col :cols="!dense ? 9 : 12" class="py-0">
        
        <v-row dense class="ma-0 pa-0">
            
            <v-col cols="4" class="pr-1" v-if="field && field.SUBFLD && field.SUBFLD.L">
                <v-text-field v-model="localValue.L" 
                    :label="dense ? field.SUBFLD.L.NAME : null"
                    :disabled="field.SUBFLD.L.DISABLED" 
                    :maxlength="field.SUBFLD.L.MAXLEN"
                    :rules="getValidators(field.SUBFLD.L)" 
                    :dense="dense" 
                    :style="{ maxWidth: fieldWidth }" 
                    v-bind="showIcons ? { appendIcon: 'mdi-arrow-right' } : {}">
                </v-text-field>
            </v-col>

            <v-col cols="4" class="px-1" v-if="field && field.SUBFLD && field.SUBFLD.B">
                <v-text-field v-model="localValue.B" 
                    :label="dense ? field.SUBFLD.B.NAME : null"
                    :disabled="field.SUBFLD.B.DISABLED" 
                    :maxlength="field.SUBFLD.B.MAXLEN"
                    :rules="getValidators(field.SUBFLD.B)" 
                    :dense="dense" 
                    :style="{ maxWidth: fieldWidth }" 
                    v-bind="showIcons ? { appendIcon: 'mdi-arrow-top-right' } : {}">
                </v-text-field>
            </v-col>

            <v-col cols="4" class="pl-1" v-if="field && field.SUBFLD && field.SUBFLD.H">
                <v-text-field v-model="localValue.H" 
                    :label="dense ? field.SUBFLD.H.NAME : null"
                    :disabled="field.SUBFLD.H.DISABLED" 
                    :maxlength="field.SUBFLD.H.MAXLEN"
                    :rules="getValidators(field.SUBFLD.H)" 
                    :dense="dense" 
                    :style="{ maxWidth: fieldWidth }" 
                    v-bind="showIcons ? { appendIcon: 'mdi-arrow-up' } : {}">
                </v-text-field>
            </v-col>
        </v-row>
        </v-col>
</v-row>
</template>

<script>
import fieldMixin from '../mixins/field';
import helperMixin from '../mixins/helper';

export default {
  name: 'aedVolumeField',
  mixins: [fieldMixin, helperMixin],

  props: {
    field: Object,
    value: Object,       // { L: '', B: '', H: '' }
    showIcons: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    fieldWidth: {
      type: [String, Number],
      default: '80px'
    }
  },

  data() {
    return {
      localValue: { L: "", B: "", H: "" }
    };
  },

  watch: {
    value: {
      handler(newVal) {
        if (!newVal) return;

        if (
          newVal.L !== this.localValue.L ||
          newVal.B !== this.localValue.B ||
          newVal.H !== this.localValue.H
        ) {
          this.localValue = { ...newVal };
        }
      },
      immediate: true
    },

    localValue: {
      handler(newVal) {
        this.$emit("input", { ...newVal });
      },
      deep: true
    }
  }
};
</script>
